import useSWR from "swr";
import get from "lodash/get";
import find from "lodash/find";
import upperFirst from "lodash/upperFirst";

import { isOnStock, isStockOnTheWay, isOnSupplierStoreOnly } from "utils/index";
import { useTranslation } from 'next-i18next';

const TimeToArrivalRow = ({ styles, children }) => {
  const { t } = useTranslation();
  return (
  <div className={styles.row}>
    <div className={`${styles.col} ${styles.label}`}>{upperFirst(t('product:you can have at home'))}:</div>
    <div className={`${styles.col} ${styles.value}`}>
      <span className={get(styles, "time-to-arrival")}>{children}</span>
    </div>
  </div>
)};

const TimeToArrival = ({ product, styles, staticBlocks }) => {
  const { t } = useTranslation();
  const { active, availability, store } = product;
  if (active && availability) {
    return (
      <TimeToArrivalRow styles={styles}>
        {!isOnSupplierStoreOnly(store) && isOnStock(store) ? (
          <div
            dangerouslySetInnerHTML={{
              __html: get(
                find(staticBlocks, {
                  hash: "product_availability_time_01",
                }),
                "content",
                t("product:in 2 working days")
              ),
            }}
          />
        ) : null}

        {isOnSupplierStoreOnly(store) && isOnStock(store) ? (
          <div
            dangerouslySetInnerHTML={{
              __html: get(
                find(staticBlocks, {
                  hash: "product_availability_time_02",
                }),
                "content",
                t("product:in 2-4 working days")
              ),
            }}
          />
        ) : null}

        {isStockOnTheWay(store) && !isOnStock(store) ? (
          <div
            dangerouslySetInnerHTML={{
              __html: get(
                find(staticBlocks, {
                  hash: "product_availability_time_03",
                }),
                "content",
                t("product:in 2 working days from arrival to stock")
              ),
            }}
          />
        ) : null}
      </TimeToArrivalRow>
    );
  }

  if (active && !availability && (isOnStock(store) || isStockOnTheWay(store))) {
    return (
      <TimeToArrivalRow styles={styles}>
        {isStockOnTheWay(store) ? (
          <div
            dangerouslySetInnerHTML={{
              __html: get(
                find(staticBlocks, { hash: "product_availability_time_03" }),
                "content",
                t("product:in 2 working days from arrival to stock")
              ),
            }}
          />
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: get(
                find(staticBlocks, { hash: "product_availability_time_02" }),
                "content",
                t("product:in 2-4 working days")
              ),
            }}
          />
        )}
      </TimeToArrivalRow>
    );
  }

  return null;
};

const AvailabilityRow = ({ styles, children }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.row}>
      <div className={`${styles.col} ${styles.label}`}>{upperFirst(t('product:availability'))}:</div>
      <div className={`${styles.col} ${styles.value}`}>{children}</div>
    </div>
  );
};

const Availability = ({ product, styles }) => {
  const { data: staticBlocks } = useSWR(
    `/api/lib/v1/blocks`,
    (url) => fetch(url).then((r) => r.json()),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  const { storeStatus } = product;
  const count = get(product, "store[0].count", 0);
  const message = get(storeStatus, "message");

  return (
    <>
      <AvailabilityRow styles={styles}>
        {storeStatus?.available ? (
          <>
            {count == 1 ? (
              <div
                className={`${styles.availability} ${styles.available}`}
                dangerouslySetInnerHTML={{
                  __html: get(
                    find(staticBlocks, {
                      hash: "product_availability_store_01",
                    }),
                    "content",
                    message
                  ),
                }}
              />
            ) : (
              ""
            )}
            {count > 1 && count <= 5 ? (
              <div
                className={`${styles.availability} ${styles.available}`}
                dangerouslySetInnerHTML={{
                  __html: get(
                    find(staticBlocks, {
                      hash: "product_availability_store_02",
                    }),
                    "content",
                    message
                  ),
                }}
              />
            ) : (
              ""
            )}
            {count > 5 ? (
              <div
                className={`${styles.availability} ${styles.available}`}
                dangerouslySetInnerHTML={{
                  __html: get(
                    find(staticBlocks, {
                      hash: "product_availability_store_03",
                    }),
                    "content",
                    message
                  ),
                }}
              />
            ) : (
              ""
            )}
          </>
        ) : (
          <span
            className={`${styles.availability} ${
              get(storeStatus, "deliveryDate.date")
                ? styles.arriving
                : styles.unavailable
            }`}
          >
            {get(storeStatus, "deliveryDate.date") ? "Očakávame" : ""}{" "}
            {get(storeStatus, "message")}
          </span>
        )}
      </AvailabilityRow>
      <TimeToArrival
        product={product}
        styles={styles}
        staticBlocks={staticBlocks}
      />
    </>
  );
};

export default Availability;
